const messages = ["failed to fetch", "network error", "fetch failed", "load failed"];

export function isNetworkError(error: unknown): boolean {
	if (!(error instanceof TypeError)) {
		return false;
	}
	if (!navigator.onLine) {
		return true;
	}

	if (typeof error.cause === "object" && error.cause && "name" in error.cause) {
		return error.cause.name === "NetworkError";
	}

	const errorMessage = error.message.toLowerCase();
	return messages.some((message) => errorMessage.includes(message));
}
